module.exports = __webpack_public_path__ + "static/img/200189.52ef3596.png";